export const dashboard = {
  en: {
    title: "Dashboard Overview",
    subtitle: "Welcome to Solariis Intelligence Platform",
    keyMetrics: "Key Metrics",
    activeTasks: "Active Tasks",
    tasksInProgress: "Tasks in progress",
    completed: "Completed",
    last7Days: "Last 7 days",
    companies: "Companies",
    // TKT-2026-0703: companies tile description (was incorrectly using
    // projectBoardDesc).
    companiesDesc: "Manage all client companies and their teams",
    activeAccounts: "Active accounts",
    scheduledPosts: "Scheduled Posts",
    readyToPublish: "Ready to publish",
    quickActions: "Quick Actions",
    projectBoard: "Project Board",
    projectBoardDesc: "Manage company projects and track task progress",
    serviceRequests: "Service Requests",
    serviceRequestsDesc: "Review and manage incoming service requests",
    socialMedia: "Social Media",
    socialMediaDesc: "Plan and schedule social media content",
    pending: "pending",
    scheduled: "scheduled",
    recentActivity: "Recent Activity",
    viewAll: "View All",
    activityComingSoon: "Activity tracking coming soon",
    activityDesc: "Task and service events will appear here",
    noActivity: "No recent activity",
    noActivityDesc: "Events will appear here as your team works",
    serviceCatalog: "Service Catalog",
    manage: "Manage",
    manageOfferings: "Manage your service offerings",
    configureServices: "Configure services, pricing, and tiers",
    failedToLoad: "Failed to load dashboard",
    retry: "Retry",
    loadingDashboard: "Loading dashboard",
  },
  es: {
    title: "Resumen del Panel",
    subtitle: "Bienvenido a la Plataforma de Inteligencia Solariis",
    keyMetrics: "Métricas Clave",
    activeTasks: "Tareas Activas",
    tasksInProgress: "Tareas en progreso",
    completed: "Completadas",
    last7Days: "Últimos 7 días",
    companies: "Empresas",
    // TKT-2026-0703: descripción del tile de empresas.
    companiesDesc: "Gestiona todas las empresas clientes y sus equipos",
    activeAccounts: "Cuentas activas",
    scheduledPosts: "Publicaciones Programadas",
    readyToPublish: "Listas para publicar",
    quickActions: "Acciones Rápidas",
    projectBoard: "Tablero de Proyectos",
    projectBoardDesc: "Gestiona proyectos de empresas y rastrea el progreso",
    serviceRequests: "Solicitudes de Servicio",
    serviceRequestsDesc: "Revisa y gestiona solicitudes de servicio entrantes",
    socialMedia: "Redes Sociales",
    socialMediaDesc: "Planifica y programa contenido para redes sociales",
    pending: "pendientes",
    scheduled: "programadas",
    recentActivity: "Actividad Reciente",
    viewAll: "Ver Todo",
    activityComingSoon: "Seguimiento de actividad próximamente",
    activityDesc: "Los eventos de tareas y servicios aparecerán aquí",
    noActivity: "Sin actividad reciente",
    noActivityDesc: "Los eventos aparecerán aquí a medida que tu equipo trabaje",
    serviceCatalog: "Catálogo de Servicios",
    manage: "Gestionar",
    manageOfferings: "Gestiona tus servicios ofrecidos",
    configureServices: "Configura servicios, precios y niveles",
    failedToLoad: "Error al cargar el panel",
    retry: "Reintentar",
    loadingDashboard: "Cargando panel",
  },
};
